import React from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const LoadingButton = (props) => {

    const {icon, loading, forceDisabled} = props

    return (
        <Button {...props} disabled={(props.hasOwnProperty('forceDisabled')) ? forceDisabled : (props.disabled || loading)}>
            <FontAwesomeIcon
                color="#fff"
                icon={loading ? 'spinner' : icon}
                spin={loading}
            />
            {props.children}
        </Button>
    )
}

LoadingButton.propTypes = {
    icon: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    forceDisabled: PropTypes.bool
}

export default LoadingButton